import { CRUD, CrudModel } from '../../classes'
import { EstimateCharge } from './estimate-charge'
import { EstimateTemplateData } from './estimate-template.data'

@CRUD({
  base: '/crud/estimate-templates',
})
export class EstimateTemplateModel extends CrudModel {
  name: string
  facilityId: string
  charges?: EstimateCharge[]

  constructor(data?: EstimateTemplateData) {
    super(data, true)
  }

  override toJSON() {
    return Object.assign(super.toJSON(), {
      name: this.name,
      facilityId: this.facilityId,
      charges: this.charges,
    })
  }

  get hasPBCharges() {
    return this.charges?.some(charge => charge.type === 'pb')
  }

  get hasHBCharges() {
    return this.charges?.some(charge => charge.type === 'hb')
  }
}
